import SelectModeEnum from "@/enums/SelectModeEnum";
import { SingleMode } from "./SingleMode";
import { MultiAdvancedMode } from "./MultiAdvancedMode";
import { MultiSimpleMode } from "./MultiSimpleMode";
import { MultiExcludedMode } from "./MultiExcludedMode";
import FilterTreeStore from "../FilterTreeStore";
import { ISelectModeStrategy } from "./ISelectModeStrategy";

export const SelectModeRegistry: Record<SelectModeEnum, new (context: FilterTreeStore) => ISelectModeStrategy> = {
    [SelectModeEnum.Single]: SingleMode,
    [SelectModeEnum.MultiAdvanced]: MultiAdvancedMode,
    [SelectModeEnum.MultiSimple]: MultiSimpleMode,
    [SelectModeEnum.MultiExcluded]: MultiExcludedMode
};

/** Racine d'un comportement de selection */
export class SelectModeStrategyFactory  {
    public static CreateInstance(mode: SelectModeEnum, context: FilterTreeStore): ISelectModeStrategy{
        let selectModeClass = SelectModeRegistry[mode];
        return new selectModeClass(context);
    }
}